<template>
  <v-app-bar
    data-vue-component-name="AppHeader"
    color="primary"
    app
  >
    <v-container>
      <v-row class="white--text">
        <v-col
          class="d-flex align-center"
          align-self="center"
          cols="10"
        >
          <v-app-bar-nav-icon class="mr-5">
            <logo-icon />
          </v-app-bar-nav-icon>

          <v-toolbar-title>Cognitive Assessment Portal</v-toolbar-title>
        </v-col>

        <v-col align-self="center" cols="2">
          Your account
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import LogoIcon from '@/assets/icons/logo.svg';

export default {
  name: 'AppHeader',
  components: {
    LogoIcon,
  },
};
</script>
